import { render, staticRenderFns } from "./NotifySection.vue?vue&type=template&id=4ba382cb&scoped=true"
import script from "./NotifySection.vue?vue&type=script&lang=js"
export * from "./NotifySection.vue?vue&type=script&lang=js"
import style0 from "./NotifySection.vue?vue&type=style&index=0&id=4ba382cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba382cb",
  null
  
)

export default component.exports